import React, { useState, useEffect } from 'react';
import { HeadingText } from '@paypalcorp/pp-react';
import { Tabs, TabPanel } from '@paypalcorp/pp-react-tabs';
import getLocaleMessages from '../../utils/localesMessages';
import ButtonFactoryV3SdkPreview from './ButtonFactoryV3SdkPreview';
import ButtonFactoryV3MobilePreview from './ButtonFactoryV3MobilePreview';
import ButtonFactoryV3DesktopPreview from './ButtonFactoryV3DesktopPreview';
import PropTypes from 'prop-types';
import { StyleSheet, css } from '../../../utility/paypalAphrodite';
import { trackEventWithData } from '../../utilsV3/analytics';
import { isGuestFormPreview } from '../../utils/buttonFactoryUtils';

const STYLES = StyleSheet.create({
  previewTabWrapper: {
    paddingLeft: '15.725em',
  },
});

const { navigator: { fullPage: { desktop, mobile } } = {} } = getLocaleMessages(
  'buttonsV3/buttonPreview'
);
const { previewTitle, previewTitlePayment } =
  getLocaleMessages('buttonsV3/common');

const PreviewNavigator = ({
  currentStep,
  formValues: { useFullPageExperience = 'yes' } = {},
  fptiSpec = {},
  isMobile,
} = {}) => {
  const [selectedTabIdx, setSelectedTabIdx] = useState(0);
  const renderFullPagePreview = useFullPageExperience === 'yes';

  const handleTabClick = (e, tabIdx) => {
    trackEventWithData(fptiSpec, {
      step: currentStep,
      link: tabIdx === '0' ? 'desktop' : 'mobile',
    });
    setSelectedTabIdx(tabIdx); // Second argument from pp-react <Tabs/> onClick prop is the clicked tab index
  };

  useEffect(() => {
    setSelectedTabIdx(0);
  }, [useFullPageExperience]);

  const previewTabs = [
    { label: desktop, id: 'desktop', panelId: 'desktop' },
    { label: mobile, id: 'mobile', panelId: 'mobile' },
  ];
  const isGuestPagePreview = isGuestFormPreview(currentStep);

  return (
    <>
      <HeadingText size="sm" className="preview-tabs-header">
        {isGuestPagePreview ? previewTitlePayment : previewTitle}
      </HeadingText>
      <Tabs
        name={renderFullPagePreview ? 'fullPagePreview' : 'popUpPreview'}
        selectedTabIdx={selectedTabIdx}
        center
        tabs={previewTabs}
        onClick={handleTabClick}
        tabsWrapperClassName={css(STYLES.previewTabWrapper)}
        className="preview-tabs-container"
      >
        <TabPanel
          className="preview-renderer"
          id={renderFullPagePreview ? 'desktop' : 'sdk'}
        >
          {renderFullPagePreview ? (
            <ButtonFactoryV3DesktopPreview
              showPPHeader={isGuestPagePreview && !isMobile}
            />
          ) : (
            <ButtonFactoryV3SdkPreview
              isGuestPagePreview={isGuestPagePreview}
            />
          )}
        </TabPanel>
        <TabPanel className="preview-renderer" id="mobile">
          <ButtonFactoryV3MobilePreview
            isGuestPagePreview={isGuestPagePreview}
          />
        </TabPanel>
      </Tabs>
    </>
  );
};

PreviewNavigator.propType = {
  currentStep: PropTypes.number,
  formValues: PropTypes.object,
  fptiSpec: PropTypes.object,
  isMobile: PropTypes.bool,
};

export default PreviewNavigator;
